
[
    {
        "accountUuid": "79e17b87-9540-4a92-9f1c-5612e65261d2",
        "moduleAssignmentUuid": "a998e96e-dbaa-4660-9a8d-22e4a5f36afc",
        "teamUuids": [
        "3c4f9e2a-8b1e-4c7f-91d4-2a6d7b5f8e3a",
        "5d6e7f8a-9b2c-4d8f-92e5-3b7e8c9f0a4b"
        ],
        "totalDurationInSeconds": 261000,
        "avgSessionsPerActiveUser": 6.1,
        "percentCompleted": 33.0,
        "avgSessionsToCompleted": 4.9,
        "percentCertifiedFirstTry": 0,
        "completed": 18,
        "inProgress": 21,
        "outOfAttempts": 0,
        "notStarted": 15,
        "avgFirstCertifiedScore": null,
        "uuid": null
    },
    {
        "accountUuid": "79e17b87-9540-4a92-9f1c-5612e65261d2",
        "moduleAssignmentUuid": "a998e96e-dbaa-4660-9a8d-22e4a5f36afb",
        "teamUuids": [
        "7e8f9a0b-1c3d-4e9f-93f6-4c8f9d0e1b5c",
        "9f0a1b2c-3d4e-5f6a-94e7-5d9e0f1a2b6d"
        ],
        "totalDurationInSeconds": 195840,
        "avgSessionsPerActiveUser": 5.3,
        "percentCompleted": 74.0,
        "avgSessionsToCompleted": 3.8,
        "percentCertifiedFirstTry": 0,
        "completed": 40,
        "inProgress": 11,
        "outOfAttempts": 0,
        "notStarted": 3,
        "avgFirstCertifiedScore": null,
        "uuid": null
    },
    {
        "accountUuid": "79e17b87-9540-4a92-9f1c-5612e65261d2",
        "moduleAssignmentUuid": "a998e96e-dbaa-4660-9a8d-22e4a5f36afd",
        "teamUuids": [
        "2c3d4e5f-6a7b-8c9d-97e0-8a2b3c4d5e9f",
        "3c4f9e2a-8b1e-4c7f-91d4-2a6d7b5f8e3a"
        ],
        "totalDurationInSeconds": 175680,
        "avgSessionsPerActiveUser": 4.3,
        "percentCompleted": 87.0,
        "avgSessionsToCompleted": 2.9,
        "percentCertifiedFirstTry": 0,
        "completed": 47,
        "inProgress": 2,
        "outOfAttempts": 0,
        "notStarted": 5,
        "avgFirstCertifiedScore": null,
        "uuid": null
    },
    {
        "accountUuid": "79e17b87-9540-4a92-9f1c-5612e65261d2",
        "moduleAssignmentUuid": "a998e96e-dbaa-4660-9a8d-22e4a5f36afa",
        "teamUuids": [
        "0a1b2c3d-4e5f-6a7b-95c8-6e0f1a2b3c7e",
        "1b2c3d4e-5f6a-7b8c-96d9-7f1a2b3c4d8f"
        ],
        "totalDurationInSeconds": 355680,
        "avgSessionsPerActiveUser": 5.9,
        "percentCompleted": 74.0,
        "avgSessionsToCompleted": 4.2,
        "percentCertifiedFirstTry": 0,
        "completed": 40,
        "inProgress": 8,
        "outOfAttempts": 0,
        "notStarted": 6,
        "avgFirstCertifiedScore": null,
        "uuid": null
    },
    {
        "accountUuid": "79e17b87-9540-4a92-9f1c-5612e65261d2",
        "moduleAssignmentUuid": "7d820963-abd8-4452-9490-9ad856f69723",
        "teamUuids": [
        "0a1b2c3d-4e5f-6a7b-95c8-6e0f1a2b3c7e",
        "1b2c3d4e-5f6a-7b8c-96d9-7f1a2b3c4d8f"
        ],
        "totalDurationInSeconds": 34920,
        "avgSessionsPerActiveUser": 0,
        "percentCompleted": 98.0,
        "avgSessionsToCompleted": 0,
        "percentCertifiedFirstTry": 87.0,
        "completed": 53,
        "inProgress": 1,
        "outOfAttempts": 0,
        "notStarted": 0,
        "avgFirstCertifiedScore": 4.0,
        "uuid": null
    },
    {
        "accountUuid": "79e17b87-9540-4a92-9f1c-5612e65261d2",
        "moduleAssignmentUuid": "e1fe4f82-11f2-48ed-83d6-f14f85db0b29",
        "teamUuids": [
        "7e8f9a0b-1c3d-4e9f-93f6-4c8f9d0e1b5c",
        "9f0a1b2c-3d4e-5f6a-94e7-5d9e0f1a2b6d"
        ],
        "totalDurationInSeconds": 54360,
        "avgSessionsPerActiveUser": 0,
        "percentCompleted": 76.0,
        "avgSessionsToCompleted": 0,
        "percentCertifiedFirstTry": 90.7,
        "completed": 41,
        "inProgress": 10,
        "outOfAttempts": 3,
        "notStarted": 0,
        "avgFirstCertifiedScore": 4.0,
        "uuid": null
    }
]